//备注：为保证文档可维护性 翻译时 请注意以下事项：
// 1。请按照该文件的格式翻译，只翻译中文部分
// 2。所有的标点符号按照原样保留
// 3。空格需按照原样保留
// 4。举例说明：
// 辛苦翻译！
export const m = {
  //通用
  common: {
    delete: '删除',
    edit: '编辑',
    more: '更多',
    sure: '确定',
    cancle: '取消',
    submit: '提交',
    add: '添加',
    companyName: '公司名称',
    mail: '邮箱',
    tel: '手机',
    telPhone: '手机号',
    phone: '电话',
    optional: '选填',
    position: '职位',
    industry: '行业',
    channel: '渠道',
    name: '姓名',
    userName: '用户名',
    nickName: '昵称',
    save: '保存',
    prompt: '提示',
    all: '全部',
    operate: '操作',
    back: '返回',
    close: '关闭',
    number: '序号',
    create_time: '创建时间',
    content: '内容',
    status: '状态',
    success: '成功',
    fail: '失败',
    fresh: '刷新',
    remove: '移除',
    send: '发送',
    count: '数量',
    time: '时间',
    date: '日期',
    import: '导入',
    export: '导出',
    detail: '查看详情',
    to: '至',
    start_time: '开始日期',
    end_time: '结束日期',
    choosed:'已选择',
    choose_count:'条',  //表示已选择多少条数据的单位
    please:'请',
    show_video:'点击查看使用视频',
    open:'开启',
    page:'每页记录数',
    page_holder:'请选择页码',
  },

  //验证相关  validate
  mail_err: '请输入正确的邮箱！',
  telPhone_empty: '请输入正确的电话号码！',
  tel_empty: '手机号不能为空！',
  tel_err: '请输入正确的手机号！',
  pass_empty: '请输入密码！',
  pass_err: '密码必须是6到15个字符组成！',
  feedBackContent_empty: '请输入反馈内容！',
  company_length: '公司名称不能超过50字！',
  company_address_length: '公司地址不能超过80字！',
  checkbox_choose_one: '请至少选择一项想要被删除的条目！',
  file_empty: '请选择要导入的文件！',
  only_support: '只支持以下格式文件:',
  no_support: '不支持该类型的文件',

  //操作提示
  cancle_delete: '取消删除',
  delete_succ: '删除成功！',
  add_succ: '添加成功！',
  edit_succ: '编辑成功！',
  clear_succ: '清空成功！',
  post_succ: '提交成功！',
  set_succ:'设置成功！',
  //批量操作
  batch_operate: '批量操作',
  batch_import: '批量导入',
  batch_deal: '批量处理',
  all_export: '全部导出',
  bacth_export: '批量导出',
  batch_delete: '批量删除',
  import_err: '导入失败',
  import_progress: '导入进度',
  importing: '导出中',


  //headerComponent 头部
  customerService: '智能客服',
  robot: '机器人',
  platform: '工作台',
  globalSetting: '全局设置',
  userInfo: '个人中心',
  feedBack: '意见反馈',


  //feedback 意见反馈 弹窗
  feedBackContent: '反馈内容',
  loginOut: '退出',
  help: '帮助',
  user: '用户',
  paradigm: '第四范式',
  videoCourse: '视频教程',
  operateGuide: '操作指南',
  issueConsult: '问题咨询',
  newuserGuide: '新手指南',


  //新手指南 步骤
  newuserGuide_step: {
    newuserGuide_error: '您正在新手引导中...',
    start: '从这里进入可以让我拥有更多技能哦！',
    know: '知道了',
    complete_info: '亲爱的主人, 请完善你的信息',
    complete_info_s: '完善信息成功',
    complete_info_f: '完善信息失败, 原因是: ',
    know_channel: '了解产品的渠道',
    rule_start: '主人，帮我开启问答对话的技能吧',
    have_start: '开启这个技能后，访客咨询问题时，我就可以按照主人配置的规则代替主人回答啦！',
    pass: '不用了',
    enter_course: '进入课程',
    use_channel_err: '请至少选择一个意向使用渠道'
  },
  contactUs: '联系我们',
  contact_us: {
    text1:'扫码关注小式机器人微信公众号',
    // text2:'或随时拨打/添加微信号18501331225进行咨询',
    text2:'添加微信号18501331225咨询',
  },
  ics_support: '技术支持',


  //systemComponent  系统
  system: {
    over_course: '结束教程',
    finish: '完成',
    step1: '第一步：点击页面右上角的“添加问答”，进入添加业务问答页。',
    step2: '第二步：在“标准问题”处输入用户可能会问的问题，比如“买的书什么时候到货”，在“答案内容”处输入这个问题的答案 ，比如“一般物流发货后3~5天后可以送到，有问题可以随时拨打电话123456”。点击确定。您也可以尝试配置其他类型的答案。',
    step3: '第三步：点击页面左下角的“体验机器人”，输入刚才设置的问题，比如“买的书什么时候到货”，我就会回答刚才配置的答案啦！',
    step4: '第四步：把我指派到主人期望的渠道，让我发挥作用吧~',
  },


  //list 机器人列表页
  list: {
    setRobot: '设置机器人',
    baseInfo: '基本信息',
    visitor: '访客数',
    CVS: '会话数',
    CVSMSG: '消息数',
    rules: '知识规则数',
    channel: '接入渠道',
    addRobot: '添加机器人',
    robotName: '机器人名称',
    change_robotName: '修改机器人名称',
    add_err: '请输入有效的机器人名称！',
    sure_delete: '确定删除机器人?（删除后相关机器人配置都会消失，且已经接入的渠道无法正常接待访客）',
    delete_succ: '删除机器人成功！',
    language: '选择语言',
    english: '英文',
    chinese: '中文',
  },


  //channnel选项
  channelList: {
    WEB: "WEB",
    WECHAT: "微信公众号",
    APP: "APP",
    WEIBO: "微博",
    WECHAT_CP: "企业微信",
    WECHAT_PER: "个人微信",
    WECHAT_MINI_PROGRAM: "微信小程序",
    ANDROID: "安卓",
    IOS: "IOS",
    CHAT:'微信',
    OTHER:'其他',
    Android:'Android',
    API:'API',
    WECHAT_MINI_PLUGIN:'微信小程序插件',
    WECHAT_PER_GROUP:'微信助手'
  },

  dateList: {
    week: '最近一周',
    month: '最近一个月',
    three_month: '最近三个月',
  },


  //userinfo 个人中心
  userInfoInner: {
    personInfo: '个人信息',
    personInfo_succ: '个人信息修改成功！',
    personInfo_err: '个人信息修改失败！',
    bingPhoneInfo: '绑定手机号',
    bingPhoneInfo_succ: '绑定手机号成功！',
    changePhoneInfo:'修改手机号',
    changePhoneInfo_succ:'修改手机号成功！',
    bindPhone: {
      tel: '手机号码',
      imageCode: '验证码',
      imageCode_empty: '图形验证码不能为空，请输入！',
      verifyCode: '手机验证码',
      verifyCode_empty: '手机验证不能为空，请输入！',
      refresh: '点击验证码刷新',
    },
    companyInfo: '公司信息',
    companyInfo_succ: '公司信息修改成功！',
    companyInfo_err: '公司信息修改失败！',
    company: {
      name: '公司名称',
      address: '公司地址',
      mail: '公司邮箱',
      tel: '公司电话'
    },
    passwordInfo: '修改密码',
    passwordInfo_succ: '密码修改成功！',
    passwordInfo_err: '密码修改失败！',
    password: {
      old: '原密码',
      new: '新密码',
    },
    getCode: '获取验证码',
    haveSend: '已发送',
    second: '秒',
  },


  //robotLeftComponent 机器人左侧列表
  robot_left: {
    tab: '切换',
    rule_manage: '知识管理',
    rules: '业务问答',
    words: '词库管理',
    unknowQ: '未知问题',
    material: '素材管理',
    base_set: '基本设置',
    robotInfo: '机器人信息',
    autoQA: '自动应答',
    sdk: '对接渠道',
    data_statistics: '数据统计',
    history_con: '历史会话',
    reception_set: '接待设置',
    experience_robot: '体验机器人',
  },

  //rules 知识规则
  rules: {
    add_rules: '添加问答',
    clear_rules: '清空规则',
    category: '分类',
    default_category: '默认分类',
    category_holder: '请输入分类名称',
    rules_status: '规则状态',
    choose: '请选择',
    serch_rule_holder: '搜索业务问答',
    np_rules: '还没有业务问答',
    please_add: '请添加业务问答',
    conversion: '问答',
    can_use: '有用',
    cant_use: '无用',
    use_rate: '有用率',
    question: '问题',
    have_stop: '已停用',
    have_active: '已启用',
    wait_communicate: '待通过',
    answer: '答案',
    authed: '通过',
    active: '启用',
    stop: '停用',
    review: '浏览',
    importing_text: '正在导入规则，请耐心等候～',
    import_err_text: '知识规则导入失败，点击查看！',
    import_log: '导入日志',
    import_log_text: '根据导入日志修改后，您可以继续上传',
    checking: '校验中',
    opearte_info: '操作提示',
    have_editing: '有正在编辑或添加的选项未完成！',
    delete_sure: '确定删除该分类？',
    categoryName_empty: '分类名称不能为空，请重新输入！',
    delete_rules_sure: '确定删除该知识规则嘛？',
    delete_choose_rules: '确定删除选中知识规则？',
    clear_rules_sure: '清空规则将导致数据无法找回，确定清空规则吗？',
    err_log: '错误日志',
    no_err_log: '暂无错误日志',
  },

  //addRules
  add_rules: {
    star_question: '标准问题',
    star_holder:'访客可能会问的最常见问法',
    simi_question: '相似问题',
    simi_holder:'访客可能会问的其他问法，问法输入越多越准确',
    add_simi: '添加相似问题',
    star_empty: '标准问题不能为空！',
    simi_empty: '相似问题不能为空！',
    star_simi_empty: '标准问题或者相似问题不能为空，请重新输入！',
    str_err: '标准问题重复，请重新输入！',
    star_data_err: '该标准问题与数据库中问题重复，请重新输入！',
    star_simi_err: '该标准问题与相似问题中问题重复，请重新输入！',
    simi_simi_err: '该相似问题与其他相似问题重复，请重新输入！',
    simi_star_err: '该相似问题与标准问题重复，请重新输入！',
    simi_data_err: '该相似问题与数据库中问题重复，请重新输入！',
    simi_empty_err: '相似问题重复或者为空，请重新输入！',
    answer_empty: '请填写或选择答案内容！',
    post_succ1: '提交成功，等待管理员通过录入知识库！',
    post_succ2: '已生成业务问答，录入知识库！',
    rich_text: {
      title: '请输入图文标题！',
      content: '请输入图文内容！',
      cover: '请输入图文封面！',
      digest: '请输入图文摘要！',
    },
    '相似问法推荐':'相似问法推荐',
    '匹配模式':'匹配模式',
    '语义匹配':'语义匹配',
    '精确匹配':'精确匹配',
    '加为相似问题':'加为相似问题',
    '推荐问题':'推荐问题',
    '不能选择与问答库中已有问题重复的问法':'不能选择与问答库中已有问题重复的问法',
    '暂无相似问法推荐':'暂无相似问法推荐',
    '成功添加问答规则':'成功添加问答规则'
  },

  //pageComponent 分页
  page: {
    goto: '前往',
    pageSize: '页'
  },

  //tableComponent
  table: {
    level_menu_one: '一级菜单项',
    one_level: '一级菜单',
  },

  //importComponent  导入
  import: {
    step1: '第一步',
    step2: '第二步',
    down: '下载',
    wechat_template: '公众号关键词屏蔽模版',
    rule_template: '问答模版',
    word_template: '词库模版',
    word_file: '编辑完成后上传词库文件',
    rule_file: '编辑完成后上传规则文件',
    wechat_file: '编辑完成后上传公众号关键词屏蔽文件',
    upload_err: '以下情况会使文件上传失败:',
    import_introduce: '导入规则说明:',
    word_text1: '没有按照模板格式上传',
    word_text2: '词库名称字数超过255，词汇字数超过50',
    word_text3: '同一个词库中有重复的词汇/近义词',
    rule_text1: '没有按照模板格式上传',
    rule_text2: '问题栏或答案栏数据为空',
    rule_text3: '标准问题和相似问题字数超过80，答案字数超过2000',
    rule_text4: '表格和规则库中有重复的标准问题或相似问题',
    wechat_text1: '一次导入关键词数最多为100000条',
    wechat_text2: '一条关键词最多允许添加20个字符',
    wechat_text3: '同一个公众号内导入的关键字不能重复（不区分匹配方式）',
    wechat_text4: '填写了关键词后，必须填写匹配方式、公众号',
  },


  //uploadComponent  上传
  upload: {
    answer_type: '答案类型',
    answer_content: '答案内容',
    text: '文本',
    image: '图片',
    audio: '语音',
    menu: '菜单',
    rich_text: '图文'
  },

  //uploadTypeNewComponent  文件上传
  upload_type: {
    answer_holder: '请输入答案内容',
    upload: '上传',
    drop_text: '把你的数据文件拖拽至此上传',
    or: '或',
    click_upload: '点击上传',
    modify: '修改',
    material: '素材库',
    choose_material: '从素材库中选择',
    re_choose: '重新选择',
    save_material: '保存到素材库',
    view_rich_text: '预览图文效果',
    choose_send_method: '选择图文消息的发送方式：',
    choose_method1: '图文卡片形式',
    choose_method1_info: '编辑的图文答案以消息卡片的形式发送给访客，访客点击后跳转到新页面查看内容',
    choose_method2: '富文本形式',
    choose_method2_info: '编辑的图文答案以富文本的形式直接发送给访客，但如果答案内包含图片，在微信微博渠道将自动以图文卡片形式发送',
    search: '搜索',
    no_material: '没有符合条件的素材',
    pause: '暂停',
    audio_limit: '语音大小限制:2M！',
    image_limit: '图片大小限制:1M！',
    my: '我的',
  },

  //imagetextComponent  图文
  rich_text: {
    notice: '注:图文消息暂时无法自动回复到个人微信渠道',
    holder: '请输入图文内容',
    title: '图文标题',
    content: '图文内容',
    cover: '答案封面',
    cover_limit: '图片小于900像素*500像素',
    digest: '答案摘要',
    auto_get: '自动获取正文的前54个字作为摘要，点击',
    here: '这里',
    get: '获取',
    local_upload: '本地上传',
    cover_err: '图片必须宽小于900像素，高小于500像素！',
    link_err: '请先选择文字, 才能添加链接！',
  },

  //word 词库管理
  word: {
    add_words: '添加词库',
    clear_words: '清空词库',
    search_words: '搜索词库',
    no_words: '还没有词库，',
    name: '词库名称',
    importing_word: '正在导入词库，请耐心等候～',
    delete_sure: '确定删除词库?',
    clear_sure: '确定清空词库?',
    delete_choose_sure: '确定删除选中词库?'
  },

  //editWord 词库编辑
  edit_word: {
    edit: "编辑词库",
    search: '搜索词汇',
    add: '添加词汇',
    word: '词汇',
    simi_word: '近义词',
    delete_sure: '确定删除词汇？',
  },

  //unknow 未知问题
  unknow: {
    question: '未知问题统计',
    notice:'按照频率统计机器人回答不了的问题，可以将高频未知问题添加进知识库。',
    questionInner: {
      search: '搜索未知问题',
      clear: '清空',
      qus: '问题',
      fre: '频率',
      time: '时间',
      add: '添加问答',
      no: '没有未知问题',
      add_succ: '规则创建成功！',
      delete_sure: '确定删除',
      delete_batch: '确定删除未回答问题吗?',
      delete_all: '确定清空未回答问题吗?',
      que_detail: '未知问题详情',
    },
    cluster: '未知问题聚类',
    clusterInner: {
      detail: '详情',
      look_detail: '查看详情',
      no: '没有聚类结果'
    },
    rule:'规则分类',
    sta:'标准问题(80字以内)',
    simi1:'相似问法1',
    simi2:'相似问法2',
    simi3:'相似问法3',
    simi4:'相似问法4',
    answer:'答案(2000字以内)'
  },


  //meterialListComponent 素材管理
  material: {
    rich_text: '图文消息',
    no_rich: '没有图文类素材',
    no_image: '没有图片类素材',
    no_audio: '没有语音类素材',
    no_menu: '没有菜单类素材',
    add_menu: '添加菜单',
    menu_name: '菜单名称',
    menu_empty: '请输入菜单名称！',
    menu_succ: '菜单添加成功！',
    delete_sure: '确定删除素材？',
    total: '共上传',
    file: '个文件',   //备注:直接翻译文件二字就可以
    file_succ: '成功上传',
    file_err: '失败上传',
    file_reason: '失败原因:'
  },


  // menuComponent  菜单组件
  menu: {
    content: '菜单内容',
    change: '修改菜单',
    level: '级', //备注：表示几级菜单 前面量词不固定
    add_menu: '添加菜单项',
    view_image: '浏览图片',
  },

  //robotInfo  机器人信息
  robot_info: {
    '技能管理':'技能管理',
    head: '机器人头像',
    own_set: '自定义',
    set_default: '恢复默认',
    name: '机器人昵称',
    username_empty: '请输入用户名',
    service: '服务管理',
    custom: '定制',
    own_chat: '自定义闲聊',
    chat_style: '定制你想要的闲聊语音风格',
    custom_finish: '已完成定制, 您可以',
    re_custom: '重新定制',
    custom_own_chat: '定制自定义闲聊',
    chat_template: '您必须按照模板上传至少2万条问答对的txt文件才能定制自定义闲聊',
    yuliao_template: '语料模版',
    finish_upload: '编辑完成后上传语料文件',
    choose_file: '选择文件',
    only_txt: '只能上传txt文件',
    free_chat: '日常聊天',
    free_chat_msg: '与机器人的日常对话，比如发送"我饿了"',
    logistics: '物流查询',
    logistics_msg: '发送“查物流”触发，然后输入快递公司和单号后即可查询物流状态',
    couplet: '自动对联',
    couplet_msg: '发送“自动对联”或“对春联”触发，然后发送上联，机器人可以对出下联',
    poetry: '机器写诗',
    poetry_msg: '发送“写诗”“藏头诗”触发，机器人会用户输入的文字自动生成诗句',
    kg: '知识问答',
    kb_msg: '通用知识问答，比如发送“中国的面积有多大”',
    start_train: '开始训练',
    name_succ: '昵称修改成功',
    choose_image: '请选择图片文件！',
    choose_txt: '请选择txt文件！',
    head_succ: '修改头像成功！',
    set_default_succ: '恢复默认头像成功！',
    start_msg: '正在训练，根据您上传的语料的特点训练时间可能在2到7天',
  },


  //response 自动应答
  response: {
    greeting: '欢迎语',
    default: '默认回复',
    timeout: '超时回复',
    start_greet: '开启欢迎语',
    greet_sub:'每次会话开启时，系统自动向访客发送欢迎语"。',
    greet_list: '欢迎语列表',
    add_greet: '添加欢迎语',
    no_greet: '没有欢迎语',
    delete_greet: '确定删除欢迎语吗?',
    default_list: '默认回复列表',
    add_default: '添加默认回复',
    no_default: '没有默认回复',
    delete_default: '确定删除默认回复吗?',
    reply_empty: '回复不能为空！',
    reply_length_err: '回复不能超过2000个字符！',
    over_time: '超时时间',
    minute: '分钟',
    timeout_list: '超时回复列表',
    add_timeout: '添加超时回复',
    no_timeout: '没有超时回复',
    delete_timeout: '确定删除超时回复吗?',
    example:'示例如下图',
    open_overtime:'开启超时回复',
    overtime_sub:'访客在设定时间内不回复时，机器人会给出超时回复提示用户，比如"请问您还在吗"，触发超时回复后，访客如果仍不回复，会话会自动关闭。',
    opne_unknow:'开启未知问题回复',
    unknow_sub:'机器人无法回答访客提出的问题时，会给出未知问题回复，比如"抱歉，我不知道怎么回答这个问题，我会努力学习的"。',
    guess:'猜你想问',
    guess_sub:'开启后，会根据问答库自动生成菜单推送给用户。',
    unknow_list:'未知问题回复列表',
    add_unknow:'添加未知问题回复',
    no_unknow:'没有未知问题回复',
    open_similar:'开启相似问题引导',
    similar_sub:'机器人没有找到最佳答案时，推荐几个可能的相似问题，询问用户是否咨询这些问题中的其中一个',
    guide_title:'引导标题',
    reply_way:'回复方式',
    reply_all:'全部回复',
    reply_one:'随机回复一条',
    not_greet:'暂无欢迎语',
    '未知问题回复':'未知问题回复',
    '相似问题引导':'相似问题引导'
  },


  //sdk 对接渠道
  sdk:{
    put_set:'接入设置',
    web:{
      methods:'对接方式',
      exe_robot:'体验Web机器人',
      text1:'点击快速体验体验机器人, 或者点击复制URL得到我们为您生成的Web机器人页面的URL',
      quick:'快速体验',
      copy_url:'复制URL',
      put:'接入Web机器人',
      text2:'我们提供两种方法将机器人接入您的Web页面',
      method1:'方法一',
      me1_info:'Web JS接入',
      text3:'您可以使用我们提供的JS组件接入机器人。',
      text4:'直接将下面的代码粘贴到您的页面中即可接入机器人',
      text5:'机器人组件的样式可以在代码中进行配置。详情请看接入文档请参考：',
      me1_info_file:'Web JS接入文档',
      method2:'方法二',
      me2_info:'Web自定义UI接入',
      text6:'您可以自定义开发聊天窗口的样式和其他功能，只调用我们提供的接口实现机器人的功能。',
      text7:'以下Access Key作为SDK的初始化参数传入。接入文档请参考：',
      me2_info_file:'Web自定义UI接入文档',
      put_view:'接入预览',
      text8:'输入接入页面的链接点击预览, 可以预览机器人的接入效果',
      link_err:'请输入正确的链接',
      link_holder:'输入接入页面的链接',
      text9:'您的网页使用非安全连接传送，可能会被浏览器阻止，请您手动允许浏览器加载该网页',
      re_view:'预览',
      quick_set:'快捷设置',
      own_style:'自定义咨询窗口样式',
      set_button_style:'设置咨询按钮样式',
      set_button_position:'设置咨询按钮位置',
      sys_style:'系统样式',
      step1:'1. 选择入口标签样式',
      online_cus:'在线客服',
      step2:'2. 选择入口标签颜色',
      choose_view:'选择入口样式后预览',
      own_set_style:'自定义样式',
      set_dialog:'自定义设置对话框和图标的样式',
      up_icon:'1. 上传入口图标',
      icon_size:'建议尺寸300px*300px,jpg/png/gif格式',
      up_image:'上传图片',
      up_view:'上传图片后预览',
      t_b:'上下位置:',
      top:'距离页面顶部',
      bottom:'距离页面底部',
      l_r:'左右位置:',
      left:'距离页面左侧',
      right:'距离页面右侧',
      set_style:'设置对话框样式',
      bg_color:'发消息框背景颜色',
      font_color:'发消息框字体颜色',
      bg_color1:'收消息框背景颜色',
      font_color1:'收消息框字体颜色',
      title_back:'标题栏背景颜色',
      send_color:'发送按钮颜色',
      back_color:'对话框背景颜色',
      set_size:'设置对话框大小',
      font_size:'设置对话框字体大小',
      px:'像素',
      h:'对话框高度',
      w:'对话框宽度',
      copy:'复制',
      save_succ:'保存成功！',
      edit_succ:'修改成功！',
      //要邀请框
      box_style:'邀请框样式',
      change_back:'更换背景图片',
      upload_tip:'只能上传不超过2M的图片，且大小不超过800*700px',
      box_choose:'邀请框功能区域框选',
      box_close:'框选关闭区域',
      box_open:'框选打开对话框区域',
      box_open_close:'并关闭邀请框',
      pop_set:'弹出设置',
      first_time:'首次发起延时',
      re_open:'开启反复发起',
      wait_time:'发起间隔',
      max_num:'最大发起次数',
      out_line:'开启离线自动发起',
      explain:'当所有客服不在线时，依然根据规则自动弹出邀请框',
      box_show:'邀请框预览',
      mouse_down:'在虚线框内,按下鼠标',
      image_err:'图片格式不正确',
      image_max:'图片不能大于2M',
      image_h_w:'图片高度不能大于700, 宽度不能大于800!',
      web_js:'Web JS接入功能设置',
      open_box:'开启邀请框',
      sub:'邀请框在您接入的页面按照一定规律主动弹出邀请用户联系客服',
      box_set:'邀请框设置',
      color_set:'配色设置',
      pre_select:'预选方案：',
      color_default:'默认配色',
      color_wechat:'微信配色',
      color_define:'自定义',
      color_setting:'颜色设置：',
      tag_empty:'请先选择入口标签样式',
    },
    app: {
      title:'手机APP接入',
      methods: 'App接入',
      me1_info: 'App SDK接入',
      text1: '通过App SDK可将第四范式智能客服接入到您的APP中，让用户在您的App内发起客服咨询。',
      text2: '您可以自定义我们提供的聊天界面的所有UI样式；如果您自己开发了App的聊天界面，也可以调用接口实现智能客服的所有功能。',
      text3: '详细的接入方式可以参考：',
      file1: '智能客服Android SDK接入文档',
      file2: '智能客服iOS SDK接入文档',
      file3: '智能客服Android SDK下载',
      file4: '智能客服iOS SDK下载',
      text4: '接入前如果您想体验SDK的各项功能，可以扫描下方相应的二维码，下载安装示例程序：',
      support_version: '支持版本',
      v1: 'Android 4.0及以上版本',
      v2: 'IOS 8.0及以上版本',
      text5: 'Access Key是您绑定机器人的唯一标识，可通过Demo程序',
      scan: '扫码',
      auto: '手动',
      me2_info: '在App中嵌入咨询页面链接',
      text6: '如果您不希望通过SDK接入，可以将下方链接嵌入App，用户跳转到咨询页面进行咨询。但这种方法无法识别登录用户的身份和资料。',
      text7: '扫码获取Access Key',
      copy_succ: '复制成功',
    },
    public: {
      text1: '微信公众号接入',
      text2: '公众号授权接入',
      text3: '点击下方按钮，用公众号管理员的微信扫描二维码，确认授权后即完成机器人绑定。机器人可以接收用户发来的消息并回复。',
      text4: '微信公众号登录授权',
      text5: '温馨提示：',
      text6: '1. 公众号授权后对微信后台和第三方后台的配置均无影响，微信公众号后台的所有功能均可继续使用，如：群发功能、关注公众号说辞、自定义菜单、数据统计等；',
      text7: '2. 由于微信自身的消息转发方式限制，将“消息管理权限”授权给第三方平台后，用户通过公众号发送的新消息将只会发送给第三方，微信不再将消息发送到微信多客服后台。',
      text8: '在微信自定义菜单中嵌入咨询页面链接',
      text9: '请您将下方链接嵌入微信自定义菜单，用户跳转到咨询页面进行咨询。但这种方法无法识别微信用户的身份。',
      text10: '已接入微信公众号',
      text11: '2. 未验证公众号无法接入人工客服',
    },
    program: {
      text1: '授权接入',
      text2: '小程序扫码授权后可以由机器人统一接收和回复客服消息。',
      text3: '微信小程序登录授权',
      text4: '注：如果想要在小程序里出现客服咨询按钮，请在小程序代码中嵌入下面的代码',
      text5: '联系客服',
      text6: '* 按钮样式可通过代码定义，具体请参考微信小程序官方说明：',
      text7: '已接入微信小程序',
      text8:'其中参数nickName为微信昵称,avatarUrl为微信头像需要开发者自己获取后传入',
      text9:'插件接入',
      text10:'自定义设置小程序插件对话框和咨询按钮的样式：',
      text11:'扫码体验小程序插件',
      text12:'体验小程序',
      scan:'扫码',
      get:'获取AccessKey',
      text13:'2. 引入插件代码包',
      text14:'在小程序项目的app.json中声明需要引用的插件appid及版本号',
      text15:'3. 在小程序页面引入插件',
      text16:'在页面的json文件中定义需要引入的第四范式智能客服机器人插件，使用plugin://协议',
      text17:'在页面的wxml文件中声明插件（需保证在一个页面中仅引入该插件） , 其中参数nickName为微信昵称,avatarUrl为微信头像需要开发者自己获取后传入',
      text18:'Access Key需要作为插件的初始化参数传入。使用体验小程序时可以直接',
      icon_empty:'请先上传入口图标'
    },
    company: {
      wechat: '企业微信',
      no_wechat: '还没有企业微信',
      add_wechat: '请添加企业微信',
      name: '企业微信名称',
      id: '企业ID',
      time: '对接时间',
      unbind: '解绑',
      unbind_wechat: '解绑企业微信',
      text1: '如果您想要解绑该企业微信, 清点击确认按钮, 并前往企业微信后台 "企业应用" - "自建应用" - "API接收消息" 中点击删除。',
      text2: '把您要对接的企业微信名称填写在下面输入框中:',
      text3: '登录您的企业微信管理后台, 在 "我的企业" - "企业信息" 中找到企业ID(参考下图), 填入下方输入框中:',
      text4: '在企业微信管理后台 "应用与小程序" - "自建应用" 中点击 "创建应用", 创建完成后可见到AgentID和Secret, 填入下方输入框中:',
      text5: '在已创建应用内页, 找到 "接收消息" 项, 点击 "设置API接收" , 再将下方生成的URL地址复制到里面:',
      step3: '第三步',
      text6: '将上图中企业微信后台生成的Token和EncodingAESKey复制到下面的输入框中，点击保存即可。不要忘了到企业微信后台看下是否对接成功。',
      pre_step: '上一步',
      next_step: '下一步',
      com_id_err: '企业ID必须由数字字母或下划线组成',
      ag_id_err: 'AgentID必须由纯数组组成',
      sec_id_err: 'Secret必须由数字、字母、短横线或下划线组成',
      token_id_err: 'Token必须由数字或字母组成',
      aes_id_err: 'EncodingAESKey必须由数字字母或下划线组成',
      name_empty: '请输入企业微信名称',
      back_sure: '确认返回？（填写的信息可能会丢失）',
      cancle_back: '取消返回',
    },
    person: {
      wechat: '个人微信接入',
      fresh: '点击刷新',
      text1: '请用微信扫描左侧二维码，点击确认登录。',
      text2: '登录后此页面会跳转，您可以在跳转的页面里选定微信好友和微信群接入机器人。当好友发送消息，或者在群聊中@你时，机器人会主动回复消息。',
      text3: '1. 二维码可能失效，请稍等片刻刷新二维码或直接刷新页面。',
      text4: '2. 如果尝试多次登录不上，请确认',
      text5: '网页版微信',
      text6: '是否可以正常登录。',
      text9:'2. 手机扫码后可能会提示账号在其他城市登录，请忽略并继续；',
      text10:'3. 扫码授权成功后请不要在其他电脑或iPad上登录账号，否则机器人会自动离线',
      status: '状态: 已上线',
      unbind: '解除状态',
      per_auto: '好友自动回复',
      gro_auto: '微信群自动回复',
      open_auto: '开启自动回复',
      open_all_auto: '开启全部好友自动回复',
      choose_fr: '选择对哪些微信好友开启自动回复',
      per_holder: '输入微信昵称搜索好友',
      per_list: '全部好友列表',
      add_all_per: '添加全部用户',
      opened_per_list: '已开启自动回复的好友列表',
      all_remove: '全部移除',
      choose_gro: '选择对哪些微信群开启自动回复',
      gro_holder: '输入微信群昵称搜索群聊',
      gro_list: '全部群列表',
      add_all_gro: '添加全部群组',
      opened_gro_list: '已开启自动回复的群列表',
      text7: '1.请确保不要在当前扫码手机以外的设备登录, 否则机器人将会掉线, 相应服务也会中断',
      text8: '2. 手机微信顶部的"网页微信已登录"通知表示微信已成功绑定机器人服务, 请不要点击退出',
      per_put_err: '个人微信接入失败，请重新扫码尝试！',
      login_out: '您的账号已被踢出, 请重新登录！',
      open_fr:'选择对哪些好友进行自动回复',
      close_fr:'选择不对哪些好友进行自动回复',
      closed_fr:'已关闭自动回复的好友列表',
      group_at:'群@回复',
      reply_at:'回复@我的消息',
      reply_all:'回复所有消息',
      add_greet: '添加入群欢迎语',
      create_greet:'新建入群欢迎语',
      edit_greet:'编辑入群欢迎语',
      delete_sure:'确定要删除欢迎语吗？'
    },
    weibo: {
      add: '新增微博访客',
      open_file: '点击打开帮助文档',
      no_visitor: '还没有微博访客，',
      please_add: '请添加微博访客',
      accessed: '已接入微博账号',
      delete_visitor: '删除微博访客',
      delete_text: '您好，删除本条记录的同时，您还需要在微博个人主页-管理中心-粉丝服务-开发者中心-停用开发模式。具体可参考说明文档的最后一步',
      nick_empty: '请输入昵称',
      access_empty: '请输入Access Token',
      weibo_help: '微博接入说明',
      text1: '第一步：分别复制URL，AppKey，用于微博后台的填写（微博后台填写步骤见下一页）',
      text2: '第二步：将复制的URL，AppKey分别填写到该页面的输入框内，点击保存。由于微博服务不稳定，如果提示错误，请刷新页面重新尝试几次。',
      text3: '第三步：如果出现如下图所示页面，表示您已经在微博绑定成功，请复制access_token字段用于下一步的回填。由于微博服务不稳定，如果该字段为空，请刷新几次。',
      text4: '第四步：请填写微博昵称与上一步复制的access_token，点击保存，完成绑定。',
      text5: '第五步：如果想要修改绑定的机器人，或者停用机器人，请如下图所示。'
    },
    api:{
      access:'API接入',
      product:'您可以使用API功能将智能客服接入更多服务方式，参数如下：',
      show:'显示',
      detail:'详情请看',
      doc:'API使用文档',
      req_example: '请求示例如下',
      res_example: '返回示例如下',
    },
    wechat:{
      desc:'您可以使用微一助手平台通过更稳定的方式将机器人接入微信，微一助手平台提供更多专注于个人微信使用的功能服务。',
      to:'点击前往微一助手',
      sub:'继续使用智能客服，点击下方按钮，用微信扫描二维码，确认授权登录微信完成机器人绑定。机器人可以接收用户发来的消息并回复。',
      wx_qr:'个人微信授权登录',
      info:'由于平台运营需要，自2020年2月26日起，将关闭个人微信接入渠道（公众号，企业微信，小程序不受影响），为防止渠道关闭影响您的业务，请您提前接入其他渠道',
      set:'个人微信设置',
      person_set:'个人设置',
      failure:'二维码已失效，',
      re_load:'请点击重新加载',
      scan:'使用手机微信扫码登录',
      click_login:'请在手机上点击确认登录',
      unbind:'解除绑定',
      fr_msg:'好友私聊设置',
      fr_switch:'好友私聊总开关',
      text1:'若关闭此开关，以下设置均失效',
      fr_auto:'加好友自动应答',
      text2:'自动通过好友验证，并发送若干条欢迎语',
      edit_greet:'编辑欢迎语',
      fr_to_group:'好友自动入群',
      keyword_group:'触发关键词自动拉好友进指定群',
      add_keyword: '添加自动进群关键词',
      keyword:'关键词',
      group_info:'群信息',
      edit_gr_keyword:'编辑自动进群关键词',
      response: '私聊自动回复',
      fr_white:'选择进行自动回复的好友',
      fr_black:'选择屏蔽自动回复的好友',
      choose_white:'选择对哪些好友进行自动回复',
      choose_black:'选择对哪些好友屏蔽自动回复',
      load:'如果展示的好友不全, 请耐心等待, 我们在为您持续加载中',
      open_fr:'进行自动回复的好友列表',
      close_fr:'屏蔽自动回复的好友列表',
      cancle_auto:'取消自动回复',
      open_auto:'开启自动回复',
      gr_set:'群聊设置',
      gr_switch:'群总开关',
      opend_gr:'已开启自动回复的群组',
      group_set:'群组设置',
      choose_gr:'选择对哪些群进行自动回复',
      load_gr:'如果展示的群不全, 请耐心等待, 我们在为您持续加载中',
      content_detail:'群发内容详情',
      keyword_holder:'请输入关键词',
      keyword_mult:'关键词重复',
      open_list:'开启关键词进群列表',
      cancle_keyword:'取消关键词进群',
      open_keyword:'开启关键词进群',
      max_fr:'选择好友上限为500人',
      max_gr:'选择群组上限为100个',
      max_greet:'好友自动应答欢迎语最多10条',
      max_keyword:'自动进群关键词最多10个',
      delete_sure:'确定要删除关键词',
      method:'的进群机制吗？',//表示某种根据某个关键词的进群机制
      gr_msg:'好友群发和群组群发消息不超过10条',
      delete_timesend:'确定要删除定时群发内容？'
    },
    qq:{
      access:'QQ接入',
      use:'您可以使用',
      cqp:'酷Q',
      text1:'平台通过插件的方式将智能客服接入QQ，插件支持私聊自动回复和群/讨论组@回复',
      step1:'第一步：下载',
      cqp_air:'酷Q Air（免费）',
      cqp_pro:'酷Q Pro（收费）',
      install:'安装并登录QQ',
      sub:'酷 Q Air 仅支持文字消息，酷 Q Pro 可支持图片、语音、图文等更加丰富的消息',
      detail:'详情请见：',
      cqp_air_pro:'酷Q Air / Pro 功能对比',
      notice:'注：',
      no_text1:'1、图灵版与小爱版区别只是自带的插件不同，可以任选一个版本下载',
      no_text2:'2、酷Q目前仅支持Windows7及以上操作系统使用',
      step2:'第二步：安装酷Q语音组件',
      install_step:'安装步骤',
      step3:'第三步：安装智能客服插件',
      address:'下载地址',
      desc:'将下载的 com.4paradigm.bot.cpk 复制到 酷Q的app目录中',
      step4:'第四步： 配置API Key',
      desc2:'在酷Q应用设置中，启用“小式机器人”插件，点击菜单中的设置，将下面的API Key',
      write:'填入，保存后重载应用',
      finish:'配置完成！现在可以通过登录的QQ进行自动回复',
      load_err:'如果遇到插件加载失败（错误代码-103），请尝试下载安装'
    }
  },


  //history  历史会话
  history: {
    time_scope: '创建时间范围',
    choose_start: '选择开始日期',
    choose_end: '选择结束日期',
    from: '来源',
    search: '搜索访客',
    import_cur: '导出当前数据',
    con_id: '会话ID',
    visitor: '访客',
    no_con: '没有历史会话',
    con_detail: '会话详情',
    con_start: '会话开始时间',
    con_end: '会话结束时间',
    no_msg: '没有消息',
    export: '导出',
    going: '进行中',
    close: '已结束',
    con_create: '会话创建时间',
    custom: '客服',
    history_detail: '历史会话详情',
    evaluation: '评价',
    open_visitor:'打开访客端',
    copy:'备份格式',
    rule:'问答库格式'
  },


  //tranfer  转接
  transfer: {
    user: '客户',
    and: '和',
    set_con: '建立会话',
    over_con: '结束了本次会话',
    trans: '将会话转接给',
  },

  //messageRes  接收消息
  message_res: {
    ask: '问',
    click_tap: '点击触发答案推荐',
    sug_answer: '推荐答案',
    no_sug: '暂无推荐',
    identify: '识别结果',
    is_menu: '这是一个菜单',
    list1: '选项一',
    title: '标题',
    len_des: '这是一个长长的描述描述描',
    is_qustion: '您要问的是以下问题吗?'
  },


  //dataStatistic  数据统计
  data_statistic: {
    time:'时间范围',
    start: '开始时间',
    end: '结束时间',
    vi_count: '访客总数',
    con_count: '会话总数',
    msg_count: '消息总数',
    hot_rules: '热门业务问答',
    no_data: '暂无相关数据',
    vi_trend: '访客趋势图',
    con_trend: '会话趋势图',
    msg_trend: '消息趋势图',
    channel_st: '渠道统计',
    star_q: '标准问法',
    belong: '所属分类',
    hit: '命中次数',
    fit_rate: '匹配率',
    no_answer: '未回答问题',
    direct_answer: '直接回答',
    guide_answer: '引导问答',
    cur_time: '当前时间范围',
    statistic_trend: '数据统计趋势图',
    '访客统计':'访客统计',
    '问答统计':'问答统计',
  },


  //customSevice  接待设置
  custom_service: {
    '访客端设置':'访客端设置',
    '访客端咨询窗口设置':'访客端咨询窗口设置',
    '广告框窗口设置':'广告框窗口设置',
    '上传失败':'上传失败',
    '转人工设置':'转人工设置',
    '开启自动关闭会话':'开启自动关闭会话',
    '关闭会话时间':'关闭会话时间',
    '客服在指定时间无响应，将在指定时间内自动关闭会话':'客服在指定时间无响应，将在指定时间内自动关闭会话',
    open_advertisement:'开启广告框窗口',
    advertisement_title:'广告框窗口设置',
    advertisement_advice:'开启后可在web聊天窗口右侧添加自定义广告窗口',
    user_set_title:'用户端设置',
    arti_first: '开启人工优先',
    text1: '开启后, 访客发起的会话将不经过机器人直接由客服接待',
    text2: '您可以设置人工优先时间，在设定的时间内人工优先，其他时间机器人优先',
    set_time: '设置人工优先时间',
    smart_first: '开启智能转人工客服',
    text3: '系统默认机器人优先，用户点击按钮转给人工客服，可以开启并设置智能转人工的方式',
    click: '触发',
    max_limit: '最大上限',
    time_count: '次未知问题转人工', //备注：此处要表达多少次位置问题转人工 前面量词不固定
    click_keyword: '触发关键词转人工',
    show_arti: '显示转人工按钮',
    text4: '如果想要用户咨询人工客服，可以将转人工按钮显示',
    leave_msg: '开启留言联系方式',
    text5: '建议开启邮箱必填，方便访客通过邮件查询工单进度',
    input_must: '必填',
    input_no_must: '非必填',
    allot: '分配方式设置',
    text6: '系统提供两种基础分配方式，将用户分配给具体的客服：',
    text7: '轮询分配：将用户按客服账号创建时间由早到晚,轮流分配',
    text8: '饱和度分配：将用户分配到当前饱和度最低的客服(接待饱和度 = 已接待人数 / 上限人数），若饱和度相同则随机分配',
    turn_allot: '轮询分配',
    saturate_allot: '饱和分配',
    freq_first: '开启熟客优先',
    text9: '小时之内再次来访的用户会被分配给上次接待他的客服（范围在1～999之间，最多输入小数点后两位）',   ////备注：此处要表达多少小时之内  前面量词不固定
    forever: '永久',
    consult_set: '用户端咨询窗口设置',
    can_image: '允许用户上传图片',
    text10: '开启后用户可以在跟机器人聊天时发送图片',
    robot_feed: '机器人回复反馈',
    text11: '客户对机器人的回复进行是否有用的反馈, 可以在业务问答和统计模块查看机器人回答的有用率,方便完善知识库配置',
    keyword_shiled: '公众号关键词屏蔽',
    text12: '您可以设置关键词，当用户在公众号输入这些关键词时，机器人不会进行回复。完全匹配指的是访客输入的文字完全命中该关键词，包含匹配指的是输入的文字包含该关键词',
    pub_list: '公众号列表',
    keyword_set: '关键词设置',
    no_pub: '暂无公众号接入',
    equal: '完全匹配',
    contain: '包含匹配',
    clear_sure:'确定要清空',
    key:'的关键词', //表示完全匹配或包含匹配模式下的关键词
    add_keyword: '点击此处添加关键词',
    all_date: '全部日期',
    time_scope: '选择时间范围',
    mon: '星期一',
    tus: '星期二',
    wed: '星期三',
    thur: '星期四',
    fri: '星期五',
    satur: '星期六',
    sun: '星期日',
    date_empty: '请至少选择一项日期！',
    date_scope: '请选择正确的时间范围！',
    delete_time: '确定删除已设置的上下班时间嘛?',
    time_empty: '时间不能为空！！',
    time_err: '时间范围在1～999之间,最多输入小数点后两位！',
    time_nan: '请输入正确的时间！',
    to: '至',

    //人工满意度评价
    like_review: '人工满意度评价',
    like_evaluate: '满意度评价',
    text13: '配置满意度评价的标签，方便收集用户的评价和反馈',
    start_review: '开启人工满意度',
    add_review: '添加评价标签',
    set_star: '配置各星级标签',
    no_star_mark: '暂无标签, 请先添加评价标签',
    one_star: '1 星',
    two_star: '2 星',
    three_star: '3 星',
    four_star: '4 星',
    five_star: '5 星',

    //引导问题设置
    set_guide: '引导问题设置',
    text14: '机器人可以自动理解用户的问题，并结合知识库中已有的问题引导咨询',
    start_guide: '开启引导问题',
    auto_text: '自定义引导文案',
    guide_count: '引导问题个数',
    adk_qus: '要问的是以下问题吗？',
    remark_warn: '最多只能添加100个标签！',
    add_succ: '标签添加成功！',
    max_add_star: '每个星级最多只能添加20个标签！',
    delete_sure: '确定删除标签',
  },

  //分组接待
  group_recept:{
    title:'分组接待',
    text1:'开启分组接待后, 会让用户在咨询前选择业务, 系统将用户分配到对应的业务组',
    start_gro:'开启分组接待',
    name:'分组名称',
    busi_group:'对应业务组',
    change_err:'请先在下方设置分组后再开启！',
    busi_empty:'请先选择对应业务组！',
    name_empty:'请先输入业务组名称！',
    add_succ:'分组添加成功',
    delete_succ:'确定删除分组',
    no_group:'您暂无业务组',
    add_first:'请先添加',
    add_group:'添加分组接待',
    edit_recept:'编辑分组',
    add_recept:'添加分组',
    edit_succ:'分组编辑成功'
  },

  //社群运营
  commute_yunying: {
    group_info: '群消息',
    group_detail: '群消息详情',
    choose_time_per: '选择对哪些微信好友开启定时发送',
    opened_time_per: '已开启定时发送的好友列表',
    choose_time_gro: '选择对哪些微信群开启定时发送',
    opened_time_gro: '已开启定时发送的群列表',
  },


  //platform  工作台
  platform_vue: {
    search_con: '搜索访客',
    choose_user: '请选择用户开始会话',
    transfer: '转接',
    create_order: '创建工单',
    close_con: '关闭会话',
    get_history: '获取历史消息',
    text_holder: '输入"#关键字"可以搜索快捷回复内容',
    send_text: 'shift+enter换行，enter发送',
    user_info: '用户信息',
    quick_reply: '快捷回复',
    content_empty: '请输入内容',
    company: '公司',
    city: '城市',
    note: '备注',
    ip_address: 'IP地址',
    terminal: '终端',
    system: '系统',
    pack: '收起',
    open: '展开',
    image_view: '图片预览',
    order_title: '工单标题',
    order_content: '工单内容',
    order_info: '工单信息',
    agent_cus: '受理客服',
    vi_info: '访客信息',
    vi_name: '访客昵称',
    vi_username: '访客姓名',
    vi_tel: '访客手机',
    vi_mail: '访客邮箱',
    create: '创建',
    name_search: '按客服用户名, 昵称搜索',
    fresh_at: '刷新于：',
    cus_name: '客服名称',
    cus_nick: '客服昵称',
    recept_status: '接待状态',
    online: '在线',
    busy: '忙碌',
    outline: '离线',
    no_data: '暂无数据',
    title_empty: '请输入工单标题',
    content_req_empty: '请输入工单内容',
    reply_empty: '请输入回复内容',
    vi_name_empty: '请输入访客昵称',
    vi_username_empty: '请输入访客姓名',
    create_succ: '创建成功',
    transfer_err: '转接失败,您要转接的客服已离线,请选择其他客服',
    quick_err: '快捷回复只能在当前会话中使用！',
    recall: '回拨成功',
    rec: '回拨',
    search_rule:'搜索知识库',
    no_rule:'没有相关的知识库信息',
    white:'白色',
    red:'红色',
    orange:'橙色',
    yellow:'黄色',
    green:'绿色',
    blue:'蓝色',
    all:'所有',
    send_image:'发送图片',
    send_file:'发送文件',
    send_satisify:'邀请用户评价',
    rule_search:'知识库搜索',
    choose_tag:'选择标签',
    add_tel:'添加新号码',
    add_mail:'添加邮箱',
    send_review:'发送图片预览',
    have_eva:'该会话已经进行过评论, 不能再发起邀请',
    feedback_succ:'向用户发送评价邀请成功',
    no_file:'请选择文件',
    file_max:'文件不能大于10M'
  },

  //platfromLeftComponent  工作台左侧
  platform_left: {
    cur_con: '当前会话',
    hist_con: '历史会话',
    order_center: '工单中心',
    set: '设置',
    paltform_set: '工作台设置',
    open_gret: '开启人工欢迎语',
    gret_empty: '请输入欢迎语',
    con_sort: '会话排序方式',
    time_put: '按接入时间顺序',
    text1: '新接入的用户在列表最上方，用户发消息后不影响顺序',
    msg_put: '按新增消息顺序',
    text2: '有新消息的对话自动移动到列表最上方',
    open_sug: '开启自动推荐答案',
    open_last_msg: '开启后自动对用户的最后一条消息推荐答案',
    wel_word: '您好, 请问有什么可以帮您的?',
    set_succ: '工作台设置成功',
    open_sound: '开启消息提示音',
  },

  //choosecity  选择城市
  choose_city: {
    province: '省份',
    county: '区县',
  },

  //attachment  上传附件
  attachment: {
    up_atta: '上传附件(最多上传10个附件, 单个文件最大20M)',
    text1: '当前限制选择 10 个文件，本次选择了',
    text2: '个文件', //备注：此处要表达多少个文件 前面量词不固定
    text3: '共选择了',
    remove_sure: '确定移除',
    file_limit: '上传单个附件大小不能超过 20MB！',
  },


  //quickRelyComponnet  快捷回复
  quick_reply: {
    search: '搜索快捷回复内容',
    text1: '还没有设置快捷回复呢, 点击下方的按钮去设置吧~',
    pub_reply: '公共快捷回复',
    per_reply: '个人快捷回复',
    no_reply: '该分组暂无快捷回复',
    set_quick: '设置快捷回复',
    per: '个人',
    pub: '公共',
    import_relpy: '导入回复',
    export_reply: '导出回复',
    no_group: '暂无分组',
    pl_add: '请添加',
    group_empty: '请先选择分组',
    add_group: '添加新分组',
    up: '上移',
    down: '下移',
    to_top: '置顶',
    add_quick: '添加快捷语',
    category_empty: '请先选择一个分类！',
    is_delete: '是否删除',
  },


  //allset  全局设置
  all_set: {
    user_manager: '用户管理',
    sys_put: '系统对接',
    work_list_set: '工单设置',
    open_auto:'开启自动分配',
    text:'开启自动分配后, 新创建的工单将通过轮询的方式自动分配给客服。',
    tag:'工单标签',
    tag_repeat:'标签不能重名，请修改'
  },

  //userManager 用户管理
  user_manager: {
    search: '搜索用户',
    add: '添加用户',
    password: '密码',
    sure_pass: '确认密码',
    user_role: '用户角色',
    SYSTEM_ADMIN: '系统管理员',
    TENANT_ADMIN: '超级管理员',
    ADMIN: '管理员',
    TENANT_USER: '普通客服',
    max_limit: '最大接待上限',
    edit_user: '编辑用户',
    delete_sure: '此操作将永久删除用户',
    is_contin: '是否继续?',
    name_le_err: '长度在2到15个字符',
    user_limit: '用户权限',
    again_pass: '请再次输入密码',
    agian_err: '两次输入密码不一致！',
    rule_name:'问答库名称',
    all_category:'全部分类',
    limit:'权限',
    disabled:'已禁用',
    expired:'已过期',
    normal:'正常',
    limit_manager:'权限管理',
    limit_succ:'权限修改成功',
    user_max:'您的坐席已达到上限，联系商务升级解锁更多坐席'
  },
  tenant_manager: {
    add: '添加租户',
    edit: '编辑租户',
    search: '搜索租户',
    no_data: '暂无租户',
    address:'发票地址',
    phone_number: '手机号码',
    mail: '邮箱',
    user_count:'可创建客服数',
    set_phone:'请输入正确的电话号码',
    set_name: '请输入租户名',
    set_name_err: '租户名应为2到15可字符',
    new_suc:'创建租户成功!',
    company: '公司名称',
    set_company: '请输入公司名称',
    set_address: '请输入发票地址',
    name: '租户账号',
    time: '使用期限',
    tenant_name: '账号'
  },


  //systemButt  系统对接
  system_butt: {
    text1: '您可以通过iframe的方式在工作台嵌入对接页面，实现客服系统与您的CRM、订单、工单等系统的数据及功能对接。对接方式可以参考',
    butt_file: '对接文档',
    show_key: '显示密钥',
    add_pages: '添加对接页面',
    delete_sure: '确认删除对接页面',
    title_empty: '请输入页面',
    address_empty: '请输入页面地址',
    all_address: '只能输入http://或https://开头的完整地址',
    max_size: '最多输入300个字符',
    page_title: '页面标题',
    page_address: '页面地址',
    open_status: '打开状态',
    open_methods: '打开方式',
    active_status: '启用状态',
    new_page: '新页面',
    cur_page: '当前窗口',
    max_ten: '最多输入10个字符',
    text2: '最好提供https地址。http地址有时无法正常打开。',
  },

  //业务组设置
  group_list: {
    set: '业务组设置',
    belong: '所属业务组',
    default: '默认分组',
    no_list: '您还没有添加业务组。',
    text1: '业务组用来区分访客咨询的不同业务, 可以把客服配置在不同业务组中负责接待（一个客服可以在多个业务组中）。',
    text2:'您可以将客服人员划分成不同的业务组。开启分组接待后，系统会让用户在咨询前选择业务，根据选择将用户分配给对应业务组中对客服。',
    add_list: '新建业务组',
    name: '业务组名称',
    count: '组内客服数',
    id: '业务组ID',
    no_group: '暂无业务组',
    edit_list: '编辑业务组',
    name_empty: '请输入业务组名称',
    add_succ: '业务组创建成功',
    edit_succ: '业务组编辑成功',
    delete_succ: '删除业务组会影响相关的数据统计，同时会删除分组接待中相应的分组，是否继续?',
    bind_address:'绑定地址',
    text3:'选择机器人，生成绑定链接，通过此链接访问的用户将在转人工时直接转到该业务组的客服。',
    choose_robot:'选择机器人',
    create_link:'生成链接',
    copy_succ: '复制链接成功'
  },

  //work-list 工单中心
  work_list: {
    my_work: '我的工单',
    m_create_work: '我创建的工单',
    m_deal_work: '我处理的工单',
    all_work: '所有工单',
    a_un_allot: '所有未分配',
    a_dealing: '所有处理中',
    a_resolve: '所有已解决',
    a_close: '所有已关闭',
    create_channel: '创建渠道',
    work_status: '工单状态',
    work_num: '工单编号',
    user_group: '业务组',
    no_work: '暂无工单',
    num: '编号',
    update_time: '更新时间',
    receive_work: '接单',
    exit_no_perssion: '存在无权限处理的工单',
    un_allot: '未分配',
    dealing: '处理中',
    resolved: '已解决',
    colsed: '已关闭',
    cur_cus: '当前客服',
    reply_work: '回复工单',
    all_show: '所有人可见',
    only_cus_show: '仅客服可见',
    work_list: '工单列表',
    choose_err: '请选择需要批量导出的工单',
    delete_sure: '确定删除选中工单?',
    delete_sure_one: '确定删除工单',
    receive_work_succ: '接单成功',
    resolve_succ: '处理成功',
    deal_work: '处理工单',
    deal_progress: '处理进度',
    no_progress: '暂无处理访客进度',
    work_reply: '工单回复',
    work_create_info: '工单创建信息',
    creater: '创建人',
    tag:'标签',
    delete_sure_mul:'确定删除选中的',
    order_count:'条工单么？', //表示是否删除 已选中条数的工单
    unkonwn_count:'条未知问题么？'//同上
  },

  //line-list 待接入会话
  line_list: {
    title: '待接入会话',
    access: '接入',
    group: '业务组',
    no_con: '暂无待接入会话',
    success: '转接成功',
    line_time: '开始排队时间'
  },
  // 平台版
  union:{
    union: '平台版',
    common: '普通版',
    cvs:'会话记录',
    work: '工单记录'
  },

  //login 登录
  login: {
    robot: '小式智能机器人',
    cus: '您身边的智能客服',
    paradigm: '第四范式人工智能技术加持',
    advance: '全渠道分钟级接入',
    union_advance: '平台版提供多商家客服统一管理和分析统计功能',
    login: '登录',
    forget_pass: '忘记密码',
    no_id: '还没有账号?',
    create: '创建一个',
    title: '第四范式智能客服平台',
  },

  //register 注册
  register: {
    register: '注册',
    username_holder: '用户名, 2到15个英文,数字,汉字,下划线',
    pass_holder: '密码6到15个字符',
    company_holder: '公司/团队名称',
    verify_holder: '请输入验证码',
    send_verify: '发送验证码',
    second_resend: '秒后可重发', //此处表达多少秒后可以重新发送验证码  量词不固定
    read_recep: '阅读并接受',
    protol: '《第四范式智能客服云服务用户协议》',
    protol_err: '请勾选阅读并接受《第四范式智能客服云服务用户协议》',
    have_id: '已有账号, 直接',
    image_code: '图形验证码',
    image_code_holder: '请输入图形验证码',
    username_exist: '用户名已存在',
    company_empty: '请输入公司',
    company_name_empty: '请输入公司名称',
    mail_empty: '请输入邮箱地址',
    register_succ: '注册成功',
    position_empty: '请输入您的职位',
    industry_empty: '请输入您的行业',
    channel_empty: '请填写您了解我们产品的渠道',
    want_channel: '意向使用渠道',
  },


  //resetPassword  忘记或者重置密码
  reset_password: {
    reset_pass: '重置密码',
    login_page: '登录页面',
    reg_tel_holder: '请输入注册手机号',
    new_pass: '请输入新密码',
    new_pass_sure: '请确认新密码',
    validate_err: '校验不通过',
    reset_succ: '重置密码成功',
  },


  //protocol 用户协议
  protocol: {
    protocol: '第四范式智能客服云服务用户协议',
    service: '服务条款',
    info1: '欢迎您使用第四范式（北京）技术有限公司提供的智能客服云服务（以下简称：第四范式），请仔细阅读下列内容并在明确理解的前提下注册。为获得第四范式所提供的智能客服云服务，您需要同意本条款内容并按照页面上的提示完成注册程序。如果您在注册过程中勾选“同意遵守【第四范式智能客服云服务条款】”选项即表示完全接受本条款的所有内容，并且在知情的基础上明确同意按条款的规定处理和使用。如果您不接受本条款，请不要注册、使用或以其他方式访问我们的服务。“我们”：即服务提供方第四范式（北京）技术有限公司，依法独立拥有第四范式智能客服产品著作权。”本协议“、”本条款“：即【第四范式智能客服云服务使用协议】，本协议适用且仅适用于第四范式智能客服云服务，第四范式（北京）技术有限公司拥有在法律允许范围内对本协议的解释权。第四范式（北京）技术有限公司公司网址为',
    content: '服务内容',
    info2: '第四范式智能客服云服务内容由第四范式（北京）技术有限公司提供给您，我们保留随时修改本条款的权利，并会在修改后于本页面公布修改后的文本，因此，请经常查看本页。如果您继续使用我们的服务，就视同接受我们对本条款的修改。第四范式智能客服云服务主要向用户提供智能客服云服务，用户通过网站导入知识库等内容，进行必要的配置，即可通过多种渠道（包括但不限于微信，微博，手机App，Web等）使用第四范式提供的智能客服云服务。为改善智能客服服务质量，本服务会记录用户数据（包括但不限于对话历史数据、手机APP信息等）。在本服务中，您应同意在您的产品（包括但不限于移动应用客户端、移动网站、应用平台及其他终端等）中使用第四范式智能客服手机SDK工具，并且通过您与您的产品用户的服务协议/软件许可条款或其他形式的许可或授权（“用户授权”），获得您产品用户的必要同意以使得第四范式智能客服手机SDK工具有权收集有关您产品的使用情况的原始数据以及其他为提供服务所必须的用户信息。您充分理解和同意，获得用户授权是使用第四范式智能客服云服务的必要前提，因此第四范式有权监督用户授权的获取，并对未获得用户授权的产品停止服务。同时，您应赋予我们对这些数据的非专有的，全球性质的，永久的，不可撤销的，可进一步许可和使用的权利。除第四范式与您有特殊约定外，本服务所收集的的数据所有权，使用权及其知识产权，均由第四范式保留并享有相关收益。您允许第四范式在提供智能客服服务的过程中插入您指定或者第四范式指定的广告。您同意授权第四范式可以在其网站、市场推广资料和新闻报道中使用您的公司名称、商标、服务标志和或商业标识进行相关的商业推广活动。',
    rules: '使用规则',
    info4_1: '1、您需要先同意我们的服务条款及本隐私权政策，成为我们的网站注册账户，才能使用我们的服务。在您注册时，我们会要求您提供个人信息，例如您的姓名、电子邮件地址和密码、电话号码、公司名称等。这些信息视为您的身份识别信息，注册即为您同意我们用这些信息来管理您的账户，并为您提供一系列服务的访问，我们也可以利用这些信息来通知您最新的产品更新和市场活动。您对前述个人信息内容拥有所有权并独立承担全部法律义务，如因该等信息损害软件所有人或他人权益，您应承担全部赔偿责任。',
    info4_2: '2、您注册成功后，我们将给予您相应的帐号及密码，该帐号和密码由您负责保管，请您不要将您的帐号、密码转让或出借予他人使用。如您发现您的帐号遭他人非法使用，应立即通知我们并授权我们作出处理。',
    info4_3: '3、确保您在每个上网时段结束时，以正确步骤离开网站。本公司不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。除非有法律规定或司法裁定，且征得本公司的同意，否则，您的用户名和密码不得以任何方式转让、赠与或继承（与帐户相关的财产权益除外）。因他人未经授权使用您的用户名和密码造成的损失由您自行承担或依法由擅用人承担，本网站尽力保证您的帐户安全但不保证您帐户安全的绝对性。',
    info4_4: '4、对于开发者利用本服务所发布的信息，第四范式保留依据国家相关法律法规对其通讯的信息进行关键词过滤的权利，如发现开发者发送内容明确存在违反国家相关法律法规的，第四范式有权作出包括但不限于劝阻、拦截、直至向有关公安部门举报等行为。但这并不表示第四范式对开发者所发送的内容有过滤或审核的义务，也没有任何审查、审核、监督的责任或其他连带责任。开发者需自行对发送该等信息的行为承担一切责任，与第四范式无关，必要时开发者还需承担由此给第四范式造成的相关损失。',
    info4_5: '5、当您使用第四范式从您的产品终端用户或您的其他合作伙伴获得的数据时，您均已经获得充分必要的授权、同意和许可，不会与您与第三方所签署的协议或文件冲突或构成对第三方权利的侵犯；若您的产品终端用户或您的合作伙伴向您撤销上述授权及许可时，您应当采取必要的技术手段，停止针对上述产品终端用户或合作伙伴使用本服务。',
    info4_6: '6、您已经遵守并将持续遵守适用的法律、法规和监管要求，包括但不限于有关个人信息保护和隐私保护的相关政策。',
    secret: '保密条款',
    info5_1: '1、保密资料指由一方向另一方披露的所有技术及非技术信息包括但不限于产品资料，产品计划，价格，财务及营销规划，业务战略，客户信息，客户数据，研发，软件硬件，API应用数据接口，技术说明，设计，特殊公式，特殊算法等。',
    info5_2: '2、本协议任何一方同意对获悉的对方之上述保密资料予以保密，并严格限制接触上述保密信息的员工遵守本条之保密义务。除非国家机关依法强制要求或上述保密资料已经进入公有领域外，接受保密资料的一方不得对外披露。',
    info5_3: '3、本协议双方明确认可各自用户信息和业务数据等是各自的重要资产及重点保密信息。本协议双方同意尽最大的努力保护上述保密信息等不被披露。一旦发现有上述保密信息泄露事件，双方应合作采取一切合理措施避免或者减轻损害后果的产生。',
    info5_4: '4、本条款不因本协议的终止而失效。',
    protect: '隐私保护',
    info6_1: '1、为了给您提供更好的服务，当您注册或者使用第四范式时，服务器会自动记录一些信息，包括URL、IP地址、浏览器的类型和使用的语言以及访问日期和时间等。除了得到您的授权、或者相关政府部门根据法律法规的规定提出要求，我们将不会泄露您的任何信息。',
    info6_2: '2、我们可能自动从目标智能终端（包括手机、电脑和电视等）和浏览器上收集和存储您的软件信息、硬件信息、您主动上传至本网站服务器的信息及您使用偏好信息，上述信息包括但不限于您手机IMEI号，用户名，操作系统信息，您的 IP 地址，Cookie信息，GPS等位置服务使用情况，您所访问的页面等信息，但不包含任何与您业务相关的数据。',
    info6_3: '3、您同意遵守您所在地适用的有关您产品终端用户数据收集和保护的法律和行业标准，并确保您使用我们的服务完全合乎该等法律及行业标准的规定。作为第四范式智能客服服务的使用者，您必须制定、发布您的隐私政策并由您产品终端用户接受。该政策应不低于第四范式智能客服云服务的隐私保护标准，特别是：',
    notice1: '(i) 告知您有第三方合作伙伴（即第四范式）以及采用一定的技术手段收集、存储、处理和使用您的产品终端使用的数据，并说明该行为的必要性；',
    notice2: '(ii) 不向未成年人收集个人数据信息，如果您是面向未成年人的应用开发者，应保证该应用的使用在成年人的监护下进行。',
    notice3: '我们将采用业内通行的，合理的标准来保护我们所收集的数据的安全性和保密性。',
    info6_4: '4、我们会严格遵守《中华人民共和国网络安全法》中涉及的各项隐私保护条款。',
    property: '知识产权',
    info7_1: '1、本服务由第四范式（北京）技术有限公司研发。本服务的一切版权，以及与第四范式智能客服相关的所有信息内容，包括但不限于著作、图片、档案、资讯、资料、架构、页面设计，均由本公司依法拥有其知识产权。',
    info7_2: '2、除第四范式或第三方明示同意外，您无权复制、传播、转让、许可或提供他人使用上述资源，否则必须承担相应的责任。',
    info7_3: '3、第四范式尊重他人的知识产权。如果您认为相应信息对您的作品的使用已经构成版权侵犯，请通过公布于第四范式的客服电话及时通知我们，我们将按照现行法律法规的规定的版权侵权投诉程序予以处理。',
    free: '免责申明',
    condition: '如发生下述情形，本网站及第四范式不承担任何法律责任：',
    info8_1: '1、依据法律规定或相关政府部门的要求提供您的个人信息；',
    info8_2: '2、由于您的使用不当而导致任何个人信息的泄露；',
    info8_3: '3、任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的情形；',
    info8_4: '4、用户因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；',
    info8_5: '5、使用本服务可能存在的来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息而招致的风险；',
    info8_6: '6、第四范式不对用户信息的保存、修改、删除或储存失败负责。对网站上的非因第四范式故意所导致的排字错误、疏忽等不承担责任。',
    other: '其他条款',
    info9_1: '1、如果本条款中任何一条被视为废止、无效或因任何理由不可执行，该使用条件应视为可分割的且不影响任何其余条款的有效性和可执行性。',
    info9_2: '2、本服务协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若您和我们之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，您同意将纠纷或争议提交第四范式（北京）技术有限公司所在地有管辖权的法院诉讼解决。',
    info10_1: '如果您对本服务条款有任何问题或建议或有其他事情需要联系我们，请发邮件至',
  },

  //worklist shareService
  worklist_data: {
    WB_WEB: '工作台-web 访客',
    WB_APP: '工作台-App 访客',
    WB_WECHAT: '工作台-微信访客',
    LM_WEB: '留言-web 访客',
    LM_APP: '留言-App 访客',
    LM_WECHAT: '留言-微信访客',
    OTHER: '其他',
    delted: '已删除',
  },

  //新版登录页面  new_login
  index: {
    product: '产品介绍',
    resolve: '解决方案',
    guide: '用户指南',
    efficient: '客服效率提升',
    cost_save: '每年成本节省',
    transfer: '转化提升',
    four_advan: '四大优势',
    all_channel: '全渠道分钟级接入',
  },

  //付费相关提示
  pay: {
    version:'您当前版本',
    no_function:'不具备该功能，联系商务升级专业版，解锁1万条规则+系统全部功能+超值服务'
  },

  contact_bussiness:{
    business: '商务合作 Tel：18501331225（微信同号）',
    operating:'产品运营 Tel：18501331225（微信同号）'
  },

  foot:{
    name:'小式机器人',
    title:'让每一个企业都拥有自己的对话机器人',
    net:'京公网安备',
    company_empty:'请输入公司或团队名称',
    submit_succ:'提交成功，我们将尽快与您取得联系！',
    make_show:'预约演示',
  },

  nav:{
    index:'首页',
    product:'产品',
    phone:'电话机器人',
    partner:'商务合作',
    agent:'代理加盟',
    business:'联系商务',
    kefu_guide:'智能客服指南',
    phone_guide:'电话机器人指南',
    down:'下载APP',
    to_system:'进入管理后台'
  },

  agent:{
    title:'携手合作伙伴共创未来',
    sub1:'邀请合作伙伴加盟',
    sub2:'推广、经销代理小式机器人系列产品，共享千亿市场',
    apply:'申请加盟',
    person:'联系人',
    tel:'联系方式',
    apply_succ:'申请成功，我们将尽快与您取得联系！',
    person_empty:'请输入联系人',
    tel_empty:'请输入联系方式'
  },

  down_app:{
    title:'小式智能客服客户端',
    sub:'上万家客户的选择和信赖',
    iphone:'iPhone下载',
    android:'Android下载',
    content_show:'内容展示'
  },

  evaluation:{
    customer:'客服统计',
    star:'星级',
    customer_total:'客服汇总',
    cvs_count_all:'接待会话总数',
    visitor_count_all:'接待访客总数',
    customer_detail:'客服详情',
    treat_num:'最大接待数',
    cvs_count:'接待会话数',
    visitor_count:'接待访客数',
    customer_star:'客服评分',
    star_count:'人评价', //表示有多少人，前面是量词
    star_num:'星', //表示评价为几星
    no_eva:'暂无评价',
    five_star: '五星',
    four_star:'四星',
    three_star:'三星',
    two_star:'二星',
    one_star:'一星',
    count:'个数', //表示 每个星级有多少个
    star_distribute:'星级分布',
    tag_distribute:'标签分布',
    tag_name:'标签名称'
  },

  // 尝试使用中文做key
  '问答库':'问答库',
  '点击行业问答库':'点击行业问答库',
  '行业问答库':'行业问答库',
  '批量或单个添加':'批量或单个添加',
  '机器人根据':'机器人根据',
  '进行回复。':'进行回复。',
  '导入策略（当有任一以下情况发生时，则该问题将不会被导入）：':'导入策略（当有任一以下情况发生时，则该问题将不会被导入）：',
  '1、问答包中的问题在业务问答中已经存在；':'1、问答包中的问题在业务问答中已经存在；',
  '2、问答包中问题的是现有业务问答中某个问题的相似问题。':'2、问答包中问题的是现有业务问答中某个问题的相似问题。',
  '分类':'分类',
  '默认分类':'默认分类',
  '批量操作':'批量操作',
  '导入':'导入',
  '导出':'导出',
  '添加':'添加',
  '问答':'问答',
  '已选择':'已选择',
  '条':'条',
  '批量删除':'批量删除',
  '批量启用':'批量启用',
  '批量停用':'批量停用',
  '清空':'清空',
  '业务问答':'业务问答',
  '请添加':'请添加',
  '还没有':'还没有',
  '有用/无用（有用率）':'有用/无用（有用率）',
  '匹配模式':'匹配模式',
  '导入问答':'导入问答',
  '1、请按照模板格式准备需要导入的数据':'1、请按照模板格式准备需要导入的数据',
  '问答模版':'问答模版',
  ' 2、请选择需要导入的文件':' 2、请选择需要导入的文件',
  '上传文件':'上传文件',
  '注意：':'注意：',
  '1、所有相似问题不能重复':'1、所有相似问题不能重复',
  '2、文件中标准问题不能重复':'2、文件中标准问题不能重复',
  '3、当文件与系统中标准问题重复，相似问题被融合，答案被覆盖':'3、当文件与系统中标准问题重复，相似问题被融合，答案被覆盖',
  '重新上传':'重新上传',
  '原因如下：':'原因如下：',
  '不用了':'不用了',
  '进入教程':'进入教程',
  '清空问答库':'清空问答库',
  '导出问答':'导出问答',
  '全部分类':'全部分类',
  '知识规则':'知识规则',
  '进行回复':'进行回复',
  '自定义词库':'自定义词库',
  '批量导入':'批量导入',
  '全部导出':'全部导出',
  '清空词库':'清空词库',
  '添加企业内部术语，提高机器人回复准确率，比如专业术语，产品简称，部门代号等。':'添加企业内部术语，提高机器人回复准确率，比如专业术语，产品简称，部门代号等。',
  '词库名称':'词库名称',
  '词库名不能为空':'词库名不能为空',
  '公司信息':'公司信息',
  '公司名称':'公司名称',
  '公司地址':'公司地址',
  '公司邮箱':'公司邮箱',
  '公司电话':'公司电话',
  '公司联系人':'公司联系人',
  '联系人电话':'联系人电话',
  '版本信息':'版本信息',
  '当前版本':'当前版本',
  '升级':'升级',
  '机器人数':'机器人数',
  '坐席个数':'坐席个数',
  '问答规则':'问答规则',
  '个':'个',
  '次':'次',
  '年':'年',
  '任务对话':'任务对话',
  '场景':'场景',
  '到期时间':'到期时间',
  '剩余':'剩余',
  '天':'天',
  '续费':'续费',
  '消息条数':'消息条数',
  '已开通无限消息包':'已开通无限消息包',
  '消息包':'消息包',
  '共':'共',
  '已使用':'已使用',
  '服务支持':'服务支持',
  '申请服务':'申请服务',
  '服务':'服务',
  '状态':'状态',
  '产品故障修复':'产品故障修复',
  'VIP技术咨询和技术指导':'VIP技术咨询和技术指导',
  '产品使用咨询':'产品使用咨询',
  '问答库配置优化':'问答库配置优化',
  '任务对话配置和对接':'任务对话配置和对接',
  '机器人优化服务':'机器人优化服务',
  '请输入公司名称':'请输入公司名称',
  '升级获取更多权限和功能及定制，请联系商务':'升级获取更多权限和功能及定制，请联系商务',
  '公司账号':'公司账号',
  '开通服务列表':'开通服务列表',
  '套餐版本':'套餐版本',
  '付费版':'付费版',
  '免费版':'免费版',
  '套餐余额':'套餐余额',
  '当前套餐详情':'当前套餐详情',
  '开通机器人列表':'开通机器人列表',
  '开通坐席列表':'开通坐席列表',
  '价格':'价格',
  '起始日期':'起始日期',
  '终止日期':'终止日期',
  '设置机器人':'设置机器人',
  '您的使用时长已到期，该机器人已关闭。请':'您的使用时长已到期，该机器人已关闭。请',
  '立即续费':'立即续费',
  '该机器人已被系统禁用，停止工作！如需解禁，请':'该机器人已被系统禁用，停止工作！如需解禁，请',
  '联系运营人员':'联系运营人员',
  '添加机器人':'添加机器人',
  '添加机器人，还可添加':'添加机器人，还可添加',
  '您当前版本机器人总数为':'您当前版本机器人总数为',
  '升级至':'升级至',
  '请联系商务':'请联系商务',
  '升级机器人总数至':'升级机器人总数至',
  '修改机器人名称':'修改机器人名称',
  '修改机器人信息':'修改机器人信息',
  '小式机器人':'小式机器人',
  '让每一个企业都拥有自己的对话机器人':'让每一个企业都拥有自己的对话机器人',
  '您的账号没有登录权限':'您的账号没有登录权限',
  '请勾选阅读并接受《第四范式智能客服云服务用户协议》':'请勾选阅读并接受《第四范式智能客服云服务用户协议》',
  '图形验证码':'图形验证码',
  '添加问答':'添加问答',
  '您的账户已到期，相关功能已受限制，请及时续费':'您的账户已到期，相关功能已受限制，请及时续费',
  '（过期后自动降为基础版且仅保留第一个机器人）':'（过期后自动降为基础版且仅保留第一个机器人）',
  '您的消息数即将耗尽，为保证机器人的正常工作，请及时续费':'您的消息数即将耗尽，为保证机器人的正常工作，请及时续费',
  '您的消息数已耗尽，机器人已停止工作，请及时续费':'您的消息数已耗尽，机器人已停止工作，请及时续费',
  '请输入手机号':'请输入手机号',
  '请输入公司或团队名称':'请输入公司或团队名称',
  '请输入使用场景描述':'请输入使用场景描述',
  '请输入正确的手机号':'请输入正确的手机号',
  '使用场景描述':'使用场景描述',
  '请填写真实信息，虚假信息无法保证正常使用，我们会定期清理虚假信息账号':'请填写真实信息，虚假信息无法保证正常使用，我们会定期清理虚假信息账号',
  '亲爱的主人, 请完善你的信息':'亲爱的主人, 请完善你的信息',
  '提示':'提示',
  '周老师':'周老师',
  '微信手机同号':'微信手机同号',
  '商务合作':'商务合作',
  '微信同号':'微信同号',
  '运营':'运营',
  '第四范式智能客服平台':'第四范式智能客服平台',
  '词典名称':'词典名称',
  '词典名称不能为空':'词典名称不能为空',
  '词典内的所有值，如：':'词典内的所有值，如：',
  '【老师姓名】词典对应的同类词为：王林老师，王林，李静老师，李景':'【老师姓名】词典对应的同类词为：王林老师，王林，李静老师，李景',
  '词汇':'词汇',
  '添加词汇':'添加词汇',
  '编辑词典成功':'编辑词典成功',
  '新建词典成功':'新建词典成功',
  '接口名称':'接口名称',
  '请输入名称':'请输入名称',
  '请求地址':'请求地址',
  '请输入请求地址':'请输入请求地址',
  '请求类型':'请求类型',
  '请输入请求类型':'请输入请求类型',
  '输入参数':'输入参数',
  '名称':'名称',
  '参数':'参数',
  '默认值':'默认值',
  '操作':'操作',
  '请输入请求名称':'请输入请求名称',
  '请输入请求参数':'请输入请求参数',
  '输出参数':'输出参数',
  '如输出参数为':'如输出参数为',
  '取值方式':'取值方式',
  '取值':'取值',
  '参数路径格式':'参数路径格式',
  "参数路径": '参数路径',
  '今日天气':'今日天气',
  '09-20的天气':'09-20的天气',
  '请输入请求参数路径':'请输入请求参数路径',
  '输出参数名称不能重复':'输出参数名称不能重复',
  '请求参数不能重复':'请求参数不能重复',
  '编辑成功':'编辑成功',
  '搜索任务':'搜索任务',
  '添加任务':'添加任务',
  '暂时没有任务，请先':'暂时没有任务，请先',
  '任务名称':'任务名称',
  '触发问题':'触发问题',
  '启用/停用':'启用/停用',
  '重命名':'重命名',
  '任务名':'任务名',
  '任务名不能为空':'任务名不能为空',
  '请输入任务名':'请输入任务名',
  '的任务对话上限为10条，联系商务升级专业版，解锁十万条规则+多租户管理+无限会话包+无限任务对话+更多服务':'的任务对话上限为10条，联系商务升级专业版，解锁十万条规则+多租户管理+无限会话包+无限任务对话+更多服务',
  '任务名称修改成功':'任务名称修改成功',
  '新建任务成功':'新建任务成功',
  '确定要删除意图':'确定要删除意图',
  '删除意图':'删除意图',
  '成功':'成功',
  '启用':'启用',
  '停用':'停用',
  '您需要设置触发问题和机器人回复后，该任务才能启用?':'您需要设置触发问题和机器人回复后，该任务才能启用?',
  '去设置':'去设置',
  '添加接口':'添加接口',
  '暂时没有接口，请先':'暂时没有接口，请先',
  '类型':'类型',
  '编辑接口':'编辑接口',
  '该接口正在被任务使用，无法进行编辑和修改':'该接口正在被任务使用，无法进行编辑和修改',
  '确定要删除接口':'确定要删除接口',
  '删除成功':'删除成功',
  '视频教程':'视频教程',
  '任务列表':'任务列表',
  '参数词典':'参数词典',
  '接口管理':'接口管理',
  '访客关于此问题的常用表达，配置时需尽可能多的覆盖用户的不同问法方式。':'访客关于此问题的常用表达，配置时需尽可能多的覆盖用户的不同问法方式。',
  '如访客想获取老师的联系方式，那么可以设置如下触发问法：':'如访客想获取老师的联系方式，那么可以设置如下触发问法：',
  '触发问法1:老师的联系方式是多少？':'触发问法1:老师的联系方式是多少？',
  '触发问法2:老师的手机号是多少？':'触发问法2:老师的手机号是多少？',
  '触发问法3:如何联系老师':'触发问法3:如何联系老师',
  '支持划词：所划词语为回答该问题所必须的任务参数。':'支持划词：所划词语为回答该问题所必须的任务参数。',
  '如：询问老师的联系方式的任务中，机器人需获取用户语言中的【老师姓名】作为参数去词典里匹配，则可将老师二字设为任务参数。':'如：询问老师的联系方式的任务中，机器人需获取用户语言中的【老师姓名】作为参数去词典里匹配，则可将老师二字设为任务参数。',
  '请划词标识槽位，提高匹配匹配概率':'请划词标识槽位，提高匹配匹配概率',
  '添加问题':'添加问题',
  '任务参数':'任务参数',
  '回答该问题需向用户索要的参数信息。':'回答该问题需向用户索要的参数信息。',
  '在询问老师联系方式的任务中，机器人需获取用户语言中的【老师姓名】作为任务参数':'在询问老师联系方式的任务中，机器人需获取用户语言中的【老师姓名】作为任务参数',
  '参数名称':'参数名称',
  '任务参数的所有可能取值集合，机器人从用户回答中提取信息后将在参数词典里匹配。我们已经为您预置好一些常用词典，如：日期，人名，地址等，您也可以自定义词典。':'任务参数的所有可能取值集合，机器人从用户回答中提取信息后将在参数词典里匹配。我们已经为您预置好一些常用词典，如：日期，人名，地址等，您也可以自定义词典。',
  '在获取老师联系方式的对话中，任务参数老师姓名 对应【老师姓名】词典，该词典中需包含所有来时的姓名':'在获取老师联系方式的对话中，任务参数老师姓名 对应【老师姓名】词典，该词典中需包含所有来时的姓名',
  '追问问题':'追问问题',
  '追问次数':'追问次数',
  '添加任务参数':'添加任务参数',
  '机器人回答':'机器人回答',
  '当用户发问且命中答案后，配置的机器人回复。':'当用户发问且命中答案后，配置的机器人回复。',
  '您可以将对应的任务参数或接口返回值添加到机器人回复，设置多种回复方式可以让机器人显得更任性哦！':'您可以将对应的任务参数或接口返回值添加到机器人回复，设置多种回复方式可以让机器人显得更任性哦！',
  '机器人必须设置回复后此问答才会生效':'机器人必须设置回复后此问答才会生效',
  '直接回答':'直接回答',
  '接口回复':'接口回复',
  '回复类型':'回复类型',
  '接口列表':'接口列表',
  '暂无数据':'暂无数据',
  '新增接口':'新增接口',
  '接口配置':'接口配置',
  '接口返回':'接口返回',
  '添加机器人回答':'添加机器人回答',
  '暂无机器人回答':'暂无机器人回答',
  '保存中':'保存中',
  '参数KEY':'参数KEY',
  '对应任务参数':'对应任务参数',
  '该接口没有需要配置的输入参数':'该接口没有需要配置的输入参数',
  '编辑参数':'编辑参数',
  '新增参数':'新增参数',
  '请输入参数名称':'请输入参数名称',
  '在获取老师联系方式的对话中，任务参数老师姓名 对应【老师姓名】词典，该词典中需包含所有老师的姓名':'在获取老师联系方式的对话中，任务参数老师姓名 对应【老师姓名】词典，该词典中需包含所有老师的姓名',
  '请选择参数词典':'请选择参数词典',
  '请输入追问问题':'请输入追问问题',
  '新增词典':'新增词典',
  '加载中':'加载中',
  '参数名称不能重复':'参数名称不能重复',
  '机器人回复不能为空':'机器人回复不能为空',
  '触发问题不能为空':'触发问题不能为空',
  '任务编辑成功':'任务编辑成功',
  '词典搜索':'词典搜索',
  '添加词典':'添加词典',
  '暂时没有词典，请先':'暂时没有词典，请先',
  '编辑词典':'编辑词典',
  '该词典正在被任务使用无法删除':'该词典正在被任务使用无法删除',
  '确定要删除词典':'确定要删除词典',
  '有用/无用（有用率)':'有用/无用（有用率)',
  '请输入搜索内容':'请输入搜索内容',
  '最多选择':'最多选择',
  '个好友':'个好友',
  '放大':'放大',
  '缩小':'缩小',
  '像左旋转':'像左旋转',
  '向右旋转':'向右旋转',
  '重新裁剪':'重新裁剪',
  '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种':'图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
  '机器人头像':'机器人头像',
  '自定义':'自定义',
  '恢复默认':'恢复默认',
  '机器人昵称':'机器人昵称',
  '修改':'修改',
  '恢复默认头像成功':'恢复默认头像成功',
  '请选择图片文件':'请选择图片文件',
  '只支持以下格式文件':'只支持以下格式文件',
  '图片大小限制':'图片大小限制',
  '修改头像成功':'修改头像成功',
  '进入账号详情页':'进入账号详情页',
  '智能客服':'智能客服',
  '人工客服':'人工客服',
  '工单中心':'工单中心',
  '账号详情':'账号详情',
  '选择图文消息的发送方式':'选择图文消息的发送方式',
  '图文卡片形式':'图文卡片形式',
  '编辑的图文答案以消息卡片的形式发送给访客，访客点击后跳转到新页面查看内容':'编辑的图文答案以消息卡片的形式发送给访客，访客点击后跳转到新页面查看内容',
  '富文本形式':'富文本形式',
  '链接形式':'链接形式',
  '编辑的图文答案以页面链接直接发送给访客':'编辑的图文答案以页面链接直接发送给访客',
  '图片裁剪':'图片裁剪',
  '上传失败':'上传失败',
  '注意':'注意',
  '1. 当文档中某一行的标准问题或答案为空时，该行将不会被导入到问答库中':'1. 当文档中某一行的标准问题或答案为空时，该行将不会被导入到问答库中',
  '2. 当文档中某一标准问题与问答库中的标准问题完全一致时，它的相似问题会添加至问答库中，它的答案会覆盖原答案':'2. 当文档中某一标准问题与问答库中的标准问题完全一致时，它的相似问题会添加至问答库中，它的答案会覆盖原答案',
  '1. 文档中的标准问题或相似问题字数超过80，或答案字数超过2000':'1. 文档中的标准问题或相似问题字数超过80，或答案字数超过2000',
  '2. 文档中的相似问题与文档或知识库中的标准问题完全一致':'2. 文档中的相似问题与文档或知识库中的标准问题完全一致',
  '3. 文档中的标准问题有重复':'3. 文档中的标准问题有重复',
  '导入成功':'导入成功',
  '搜索':'搜索',
  '上传结果':'上传结果',
  '成功上传':'成功上传',
  '个文件':'个文件',
  '共上传':'共上传',
  '失败上传':'失败上传',
  '失败原因':'失败原因',
  '菜单名称':'菜单名称',
  '子菜单':'子菜单',
  '答案':'答案',
  '文本':'文本',
  '切换':'切换',
  '对接渠道':'对接渠道',
  '点击':'点击',
  '机器人测试':'机器人测试',
  '关闭机器人测试':'关闭机器人测试',
  '知识管理':'知识管理',
  '基础设置':'基础设置',
  '技能管理':'技能管理',
  '访客端设置':'访客端设置',
  '转人工设置':'转人工设置',
  '接入渠道':'接入渠道',
  '网站':'网站',
  '手机APP':'手机APP',
  '微信公众号':'微信公众号',
  '微信小程序':'微信小程序',
  '企业微信':'企业微信',
  '个人微信':'个人微信',
  '微博':'微博',
  '访客统计':'访客统计',
  '问答统计':'问答统计',
  '客服统计':'客服统计',
  '级分类':'级分类',
  '提交成功':'提交成功',
  '平台版':'平台版',
  '运营管理后台':'运营管理后台',
  '商务后台':'商务后台',
  '请输入图文内容':'请输入图文内容',
  '请选择图文':'请选择图文',
  '素材库':'素材库',
  '请输入正确图片地址':'请输入正确图片地址',
  '高校智能客服':'高校智能客服',
  '帮您自动准确解答95%的问题，剩下5%疑问人工回答！':'帮您自动准确解答95%的问题，剩下5%疑问人工回答！',
  '应用了人工智能的自然语言识别处理、大数据、云计算等技术，':'应用了人工智能的自然语言识别处理、大数据、云计算等技术，',
  '为学校业务部门建立统一管理的在线智能咨询服务平台':'为学校业务部门建立统一管理的在线智能咨询服务平台',
  '产品负责人： 周老师 18310505996（手机、微信）':'产品负责人： 周老师 18310505996（手机、微信）',
  '赛尔超星 高校智能客服':'赛尔超星 高校智能客服',
  '微信扫码关注高校智能客服周老师':'微信扫码关注高校智能客服周老师',
  '功能使用与技能支持':'功能使用与技能支持',
  '了解更多功能细节或购买高校智能客服产品，请您联系':'了解更多功能细节或购买高校智能客服产品，请您联系',
  '机器人问答统计':'机器人问答统计',
  '人工客服问答统计':'人工客服问答统计',
  '第三方应用对接':'第三方应用对接',
  '高校智能教学助手':'高校智能教学助手',
  '产品负责人':'产品负责人',
  '微信扫码关注高校智能教学助手周老师':'微信扫码关注高校智能教学助手周老师',
  '了解更多功能细节或购买高校智能教学助手，请您联系':'了解更多功能细节或购买高校智能教学助手，请您联系',
  '助教老师':'助教老师',
  '知识库':'知识库',
  '知识问答':'知识问答',
  '知识点':'知识点',
  '该页面存在未保存的修改, 是否坚持离开':'该页面存在未保存的修改, 是否坚持离开',
  '机器人回复用户任务结果或信息。': '机器人回复用户任务结果或信息。',
  '您可以选择直接回复让机器人统一回复指定对内容，也可以将对应的任务参数或接口返回值添加到机器人回复，并通过API实现更多逻辑处理。': '您可以选择直接回复让机器人统一回复指定对内容，也可以将对应的任务参数或接口返回值添加到机器人回复，并通过API实现更多逻辑处理。',
  '另外，设置多种回复方式可以让机器人显得更任性哦！': '另外，设置多种回复方式可以让机器人显得更任性哦！',
  '确认': '确认'
}





// WEBPACK FOOTER //
// ./src/common/lang/zh.js